export const COLORS = {
  neutral: {
    1: "#FAFAFA",
    2: "#F2F3F5",
    3: "#E9EBED",
    4: "#D0D6DD",
    5: "#AFB7BF",
    6: "#60666C",
    7: "#33383C",
    8: "#0D0E0F",
  },
  primary: {
    1: "#E9F4F3",
    2: "#DEEFED",
    3: "#BEDFDB",
    4: "#92C9C3",
    5: "#269387",
    6: "#127367",
    7: "#134943",
    8: "#081D1B",
  },
  secondary: {
    1: "#E5E3F2",
    2: "#D8D6EB",
    3: "#BFBADE",
    4: "#A59ED1",
    5: "#7E75BD",
    6: "#5F588E",
    7: "#3F3B5F",
    8: "#191726",
  },
  success: {
    1: "#B9E6CE",
    2: "#8AD6AD",
    3: "#5CC58C",
    4: "#2DB46B",
    5: "#15A657",
    6: "#128749",
    7: "#0B562D",
    8: "#07341B",
  },
  danger: {
    1: "#F9D3CC",
    2: "#F9CCD0",
    3: "#EF9180",
    4: "#E9664D",
    5: "#E02401",
    6: "#A81B01",
    7: "#701200",
    8: "#2D0700",
  },
  warning: {
    1: "#FEF7EA",
    2: "#FEEFD5",
    3: "#FDE7C0",
    4: "#FCD797",
    5: "#F8B02E",
    6: "#BA8423",
    7: "#7C5817",
    8: "#322309",
  },
  info: {
    1: "#F2F9FF",
    2: "#E5F3FF",
    3: "#CCE6FF",
    4: "#80C1FF",
    5: "#0085FF",
    6: "#006ACC",
    7: "#004280",
    8: "#00284D",
  },
};
